import qs from "query-string";

export const addQueryParams = (path, params) => `${path}?${qs.stringify(params)}`